import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from './Home';
import Detail from './Detail';

function Router() {
  return (
    <Switch>
      <Route path='/2021' component={Home} exact />
      <Route path='/2021/sessions/:index' component={Detail} exact />
      <Route path='*'>
        <Redirect to='/2021' />
      </Route>
    </Switch>
  );
}

export default Router;
